import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PBIService } from 'src/services/pbi/pbi.service';
import { Subject } from 'rxjs';
import { TaskObject } from 'src/classes/task';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDeletionModalComponent } from 'src/app/confirm-deletion-modal/confirm-deletion-modal.component';


interface SelectableOption {
  label: string;
  id: string;
  loading?: boolean;
}

@Component({
  selector: 'app-task-step-config',
  templateUrl: './task-step-config.component.html',
  styleUrls: [
    './task-step-config.component.scss',
    './../task-form.component.scss'
  ]
})
export class TaskStepConfigComponent implements OnInit, OnChanges {

  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() workspaceList: SelectableOption[];
  @Input() reportList: SelectableOption[];
  @Input() pageList: SelectableOption[];

  @Output() onWorkspaceChange = new EventEmitter<string>();
  @Output() onReportChange = new EventEmitter<string>();
  @Output() onRefreshWorkspaceClick = new EventEmitter<void>();
  @Output() onPageAdd = new EventEmitter<TaskObject>();
  @Output() onPageEdit = new EventEmitter<TaskObject>();
  @Output() onPageDelete = new EventEmitter<TaskObject>();

  @ViewChild('taskTypeSelect', { static: true }) taskTypeSelect: ElementRef;

  public pageOptions: string[] = [];
  public pageSelected: TaskObject[] = [];
  public ps: TaskObject = null;
  public pageId: number = null;

  public eventOpenmodal: Subject<any> = new Subject<any>();

  public lastSelectedWorkspaceId?: string;
  public lastSelectedReportId?: string;
  public lastSelectedPageTitle?: string;

  constructor(private powerBiApi: PBIService,
    public modalService: NgbModal) { }

  ngOnInit() {
    if (this.taskTypeSelect && this.taskTypeSelect.nativeElement) {
      this.populateTaskType();
    } else {
      setTimeout(() => {
        if (this.taskTypeSelect && this.taskTypeSelect.nativeElement) {
          this.populateTaskType();
        } else {
          console.warn("Could not populate task type");
        }
      }, 100);
    }
  }

  get TaskName() { return this.formGroup.get('TaskName'); }
  get PBIWorkspaceName() { return this.formGroup.get('PBIWorkspaceName'); }
  get PBIWorkspaceId() { return this.formGroup.get('PBIWorkspaceId'); }
  get PBIReportName() { return this.formGroup.get('PBIReportName'); }
  get PBIReportId() { return this.formGroup.get('PBIReportId'); }
  get PageList() { return this.formGroup.get('PageList'); }
  get TaskType() { return this.formGroup.get('TaskType'); }
  get PdfPassword() { return this.formGroup.get('PdfPassword'); }
  get ImageInBody() { return this.formGroup.get('ImageInBody'); }

  isCheckboxChecked(id) {
    if (this.pageSelected.includes(id)) {
      return true;
    }
  }

  isPageSelected() {
    return this.ps != null;
  }

  onPageChange(event) {

    const id: string = event.target.value;
    console.log(id)
    if (id == "") {
      this.ps = null;
      return;
    }
    this.ps = new TaskObject();
    this.ps.page = id;
    this.ps.pageView = '16:9';
    this.ps.width=0;
    this.ps.height=0;
    this.ps.type = 'I';
    this.ps.objectId = '';
    this.ps.name = this.pageList.filter(i => i.id == id)[0].label;
    this.pageId = null;
  }
  addPage(modalElement) {
    this.modalService.open(modalElement).result.then((result) => { }, async (reason) => {
      if (reason != 'Save') {
        return;
      }
      var obj = new TaskObject();
      obj.page = this.ps.page;
      obj.name = this.ps.name;
      obj.pageView = this.ps.pageView;
      obj.type = this.ps.type;
      obj.width = this.ps.width;
      obj.height = this.ps.height;
      obj.objectId=this.ps.objectId;
      if (!this.pageId) {
        this.pageSelected.push(obj);
        this.onPageAdd.emit(obj)
      }
      else{
        obj.reportOrder=this.ps.reportOrder;
        this.updatePage(obj);
        this.onPageEdit.emit(obj);
      }

    });
  }

  editPage(obj,modal){
    console.log(obj,modal);
    if(this.ps==null){
      this.ps = new TaskObject();
    }
    this.pageId=obj.reportOrder;
    this.ps.name = obj.name;
    this.ps.height=obj.height;
    this.ps.objectId = obj.objectId;
    this.ps.page = obj.page;
    this.ps.pageView = obj.pageView;
    this.ps.reportOrder=obj.reportOrder;
    this.ps.type=obj.type;
    this.ps.width=obj.width;
    this.addPage(modal);
  }

  checkConfigPage() {
    return !((this.ps.pageView != 'Custom') || (this.ps.width > 0 && this.ps.height > 0 && this.ps.pageView == 'Custom'));
  }


  async onDeletePageClick(obj: TaskObject) {
    if (await this.showConfirmDeletionModal() === true) {
      this.deletePage(obj.reportOrder);
      this.onPageDelete.emit(obj);
    }
  }


  updatePage(obj) {
    if (!obj.reportOrder) {
      throw new Error('Cannot update page without id');
    }
    for (const obj1 of this.pageSelected) {
      if (obj1.reportOrder !== obj.reportOrder) {
        continue;
      }
      obj1.name = obj.name;
      obj1.objectId = obj.objectId;
      obj1.type = obj.type;
      obj1.pageView = obj.pageView;
      obj1.page = obj.page;
      obj1.width = obj.width;
      obj1.height = obj.height;
    }
  }

  deletePage(id: number) {
    let index: number;
    for (let i = this.pageSelected.length - 1; i >= 0; i--) {
      const element = this.pageSelected[i];
      if (element.reportOrder === id) {
        index = i;
        break;
      }
    }
    if (index !== undefined && index !== null && index >= 0 && index < this.pageSelected.length) {
      this.pageSelected.splice(index, 1);
    }
  }

  async showConfirmDeletionModal(): Promise<boolean> {
    try {
      const modalRef = this.modalService.open(ConfirmDeletionModalComponent, { ariaLabelledBy: 'modal-confirm-deletion' });
      const result = await modalRef.result;
      return result === true;
    } catch(reason) {
    }
    return false;
  }

  onPageCheckboxChange(checked, id) {
    if (checked) {
      this.pageSelected.push(id);
    } else if (this.pageSelected.includes(id)) {
      this.pageSelected.splice(this.pageSelected.indexOf(id), 1);
    }
    const input = this.PageList;
    input.setValue(this.pageSelected);
    input.setErrors(this.pageSelected.length === 0 ? { required: true } : null);
    input.markAsTouched();
    input.markAsDirty();
  }

  async getToken(workspaceId: string, reportId: string) {
    try {
      return await this.powerBiApi.getReportToken(workspaceId, reportId);
    } catch (e) {
      alert(`Error on load report data. Details ${e && e.stack ? e.stack : (e instanceof Error ? e : JSON.stringify(e))}`);
    }
  }

  async onRefreshWorkspaceButtonClick() {
    this.onRefreshWorkspaceClick.emit();
  }

  async onViewClick() {
    const workspaceId = this.PBIWorkspaceId.value as string;
    const reportId = this.PBIReportId.value as string;
    const pageId = this.ps.page;

    const tokenData: any = await this.getToken(workspaceId, reportId);
    if (tokenData) {
      tokenData.page = pageId;
      this.lastSelectedWorkspaceId = workspaceId;
      this.lastSelectedReportId = reportId;
      this.lastSelectedPageTitle = this.PBIWorkspaceName.value + ' > ' + this.PBIReportName.value + ' > ' + this.ps.name;
      this.eventOpenmodal.next(tokenData);
    }
  }

  onWorkspaceChangeInternal(event) {
    const id: string = event.target.value;
    this.onWorkspaceChange.emit(id);
  }

  onReportChangeInternal(event) {
    const value = event.target.value;
    this.onReportChange.emit(value);
  }

  onWorkspaceListUpdate(previous: any, current: any) {
  }

  onReportListUpdate(previous: any, current: any) {
  }

  onPageListUpdate(previous: any, current: any) {
    if (current === undefined || !(current instanceof Array)) {
      this.pageOptions = [];
      this.pageSelected = [];
      return;
    }
    const selections = this.PageList.value;

    this.pageOptions = current.map(page => page.id);
    //this.pageSelected = this.PageList.value;
    //this.pageSelected = this.pageSelected.filter(pageId => this.pageOptions.includes(pageId));

    this.PageList.markAsUntouched();
  }

  ngOnChanges(changes: SimpleChanges) {
    const workspaceList: SimpleChange = changes.pageList;
    if (workspaceList && workspaceList.previousValue !== workspaceList.currentValue) {
      this.onWorkspaceListUpdate(workspaceList.previousValue, workspaceList.currentValue);
    }
    const reportList: SimpleChange = changes.pageList;
    if (reportList && reportList.previousValue !== reportList.currentValue) {
      this.onReportListUpdate(reportList.previousValue, reportList.currentValue);
    }
    const pageList: SimpleChange = changes.pageList;
    if (pageList && pageList.previousValue !== pageList.currentValue) {
      this.onPageListUpdate(pageList.previousValue, pageList.currentValue);
    }
  }

  populateTaskType() {
    const select = this.taskTypeSelect.nativeElement;
    const type = this.TaskType.value;
    const pdfPassword = this.PdfPassword.value;
    const imageInBody = this.ImageInBody.value;

    let value: string;
    if (type === "PNG") {
      value = imageInBody ? 'image-body' : 'image-attachment';
    } else {
      value = pdfPassword ? 'encrypted-pdf' : 'unencrypted-pdf';
    }

    select.value = value;
    this.onTaskTypeChange(value);
    return value;
  }

  onTaskTypeChange(event: any) {
    const selectValue = typeof event === "string" ? event : (event.target.value as string);

    let type: string;
    let pdfPassword: boolean;
    let imageInBody: boolean;

    switch (selectValue) {
      case "image-attachment": type = "PNG"; pdfPassword = undefined; imageInBody = false; break;
      case "image-body": type = "PNG"; pdfPassword = undefined; imageInBody = true; break;
      case "unencrypted-pdf": type = "PDF"; pdfPassword = false; imageInBody = undefined; break;
      case "encrypted-pdf": type = "PDF"; pdfPassword = true; imageInBody = undefined; break;
      default: type = "PDF"; pdfPassword = true; imageInBody = false; break;
    }

    this.TaskType.markAsDirty();
    this.TaskType.markAsTouched();
    this.TaskType.setValue(type);

    this.PdfPassword.markAsDirty();
    this.PdfPassword.markAsTouched();
    this.PdfPassword.setValue(pdfPassword);

    this.ImageInBody.markAsDirty();
    this.ImageInBody.markAsTouched();
    this.ImageInBody.setValue(imageInBody);
  }

  getWorkspaceById(id: string, fallback?: any): SelectableOption {
    for (const workspace of this.workspaceList) {
      if (workspace.id !== id) {
        continue;
      }
      return workspace;
    }
    return fallback;
  }

  getWorkspaceNameById(id: string, fallback?: string): string {
    const r = this.getWorkspaceById(id, undefined);
    return r ? r.label : fallback;
  }

  getReportById(id: string, fallback?: any) {
    for (const report of this.reportList) {
      if (!report || report.id !== id) {
        continue;
      }
      return report;
    }
    return fallback;
  }

  getReportNameById(id: string, fallback?: string) {
    const r = this.getReportById(id, undefined);
    return r ? r.label : fallback;
  }
}
